<section class="password-confirmation">
<h1 class="text-center">{{ 'Sellers.Products.PasswordConfirmation' | translate }}</h1>
<div class="alert alert-info w-100 m-auto">
  {{ 'Sellers.Products.PasswordWarning01' | translate : {normalFees: normalFees} }} <br>
  {{ 'Sellers.Products.PasswordWarning02' | translate }} <br><br>
  {{ 'Sellers.Products.PasswordWarning03' | translate : {urgentFees: urgentFees} }} <br>
  {{ 'Sellers.Products.PasswordWarning04' | translate }} <br><br>
  {{ 'Sellers.Products.PasswordWarning05' | translate : {recurringFees: recurringFees} }} <br>
  {{ 'Sellers.Products.PasswordWarning06' | translate }}
</div>
<p *ngIf="showOtp"> {{ 'FORMS.TWOFACTORAUTH.OTP.SEND_TO_PHONE' | translate : {mobile: userphone} }}</p>
<form #f="ngForm" [formGroup]="confirmPasswordForm" class="mt-3">


  <div mat-dialog-content class="mat-typography">
    <div class="row">
      <div class="col-md-6 my-3">
        <mat-form-field fxFlexFill appearance="outline">
          <mat-label>{{ 'Sellers.Products.Password' | translate }}</mat-label>
          <input matInput type="password" placeholder="{{ 'Sellers.Products.EnterPassword' | translate }}"
            formControlName="password" [type]="passwordHide ? 'password' : 'text'" name="password">
          <mat-error *ngIf="formValidator.formErrors.password">
            {{ formValidator.formErrors.password }}
          </mat-error>
        </mat-form-field>

      </div>
      <div *ngIf="this.showOtp" class="col-md-6 my-3">
        <mat-form-field fxFlexFill appearance="outline">
          <mat-label>{{ 'Sellers.Products.EnterOtp' | translate }}</mat-label>
          <input matInput type="password" placeholder="{{ 'Sellers.Products.EnterOtp' | translate }}"
            formControlName="otp" name="otp">
          <mat-error *ngIf="formValidator.formErrors.otp" style="word-wrap: break-word;">
            {{ formValidator.formErrors.otp }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div *ngIf="this.showOtp">
    <app-countdown-timer (remainingTimeOutput)="onRemainingTimeChange($event)"></app-countdown-timer>
    <button mat-flat-button type="button" color="primary" [disabled]="!showResendOtp" (click)="resendOtp()"> {{ 'FORMS.TWOFACTORAUTH.OTP.RESEND' |
      translate }}</button>
      <button [disabled]="!showResendOtp" (click)="resendOtp('WHATSAPP')" id="otpViaWhatsappBtn" class="whatsapp-label-btn"
        [ngClass]="{'disabled-btn': !showResendOtp}"> {{'Sellers.Products.ClickHereToSendViaWhatsapp' | translate}}
      </button>
  </div>
  <div class= "mat-dialog-actions" fxLayout fxLayoutAlign="center center">
    <button mat-flat-button type="submit" color="primary" [disabled]='confirmPasswordForm.invalid' (click)="onSubmit()">
      {{ 'Sellers.Products.Confirm' | translate }}
    </button>
    <button mat-flat-button type="button" (click)="cancel()">
      {{ 'Sellers.Products.Cancel' | translate }}
    </button>
  </div>

</form>
</section>
